// File: src/components/social/FollowButton/FollowButton.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";

interface FollowButtonProps {
  isFollowing?: boolean;
  onToggle?: () => void; // ✅ Optional
}

const Button = styled.button<{ isFollowing: boolean }>`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border: none;
  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ isFollowing, theme }) => 
    isFollowing ? theme.colors.secondary : theme.colors.primary};
  color: ${({ theme }) => theme.colors.buttonText};
  font-weight: ${({ theme }) => theme.fonts.fontWeightMedium};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    background: ${({ isFollowing, theme }) => 
      isFollowing ? theme.colors.secondaryHover : theme.colors.primaryHover};
  }
`;

export const FollowButton: React.FC<FollowButtonProps> = ({ isFollowing = false, onToggle }) => {
  return (
    <Button isFollowing={isFollowing} onClick={onToggle}>
      {isFollowing ? "Unfollow" : "Follow"}
    </Button>
  );
};